import React from "react";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { Row, Col } from "reactstrap";
import { commonPageStyle } from "../../../Common/Summary/styles/CommonPageStyle";
import { languageService } from "../../../../Language/language.service";
import { maintenaceDetailstyle } from "../../styles/maintenanceDetailstyle";
import Detail from "../../MaintenanceDetail/MaintenanceDetail";
import ImageArea from "../../../Common/ImageArea";
import DocumentsArea from "../../../Common/documentsArea";
import AudioArea from "../../MaintenanceDetail/AudioComponent/AudioArea";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import moment from "moment";
import { DefectCodesModel } from "./DetailViewModels/DefectCodesModel.jsx";

function Description({ m1, methods, closedBy }) {
  const { status } = m1;
  return (
    <Row>
      <Col md="12">
        <div style={themeService(maintenaceDetailstyle.fieldHeading)}> {languageService("Description")}: </div>
        <div style={themeService(maintenaceDetailstyle.MaintenanceDescriptionContainer)}>
          <div style={{ ...themeService(maintenaceDetailstyle.fieldText), maxWidth: "265px", wordWrap: "break-word" }}>
            {m1.issue && m1.issue.description}
          </div>
          <Row>
            {m1.issue && m1.issue.imgList && m1.issue.imgList.length > 0 && (
              <Col md="12">
                <ImageArea path="applicationresources" imagesList={m1.issue.imgList} imageHeight={"100px"} />
              </Col>
            )}
          </Row>
          <Row>
            {m1.documents && (
              <Col md="12">
                <DocumentsArea
                  path="assetDocuments"
                  documentList={m1.documents}
                  allowClickDownload
                  deleteDocument={methods.deleteDocumentHandle}
                  allowDeletion={false}
                />
              </Col>
            )}
          </Row>
          <Row>
            {m1.issue && m1.issue.voiceList && m1.issue.voiceList.length > 0 && (
              <Col md="12">
                <AudioArea audio={m1.issue.voiceList} />
              </Col>
            )}
          </Row>
          <Row>
            {methods.isDefectCodeButtonToShow() &&
              methods.findAssetTypeDefectsByName() &&
              methods.findAssetTypeDefectsByName().length > 0 && (
                <Col md="12">
                  <MyButton
                    onClick={(e) => {
                      methods.onDefectModelOpenMethod(true);
                    }}
                  >
                    {languageService("Defect Codes")} :
                  </MyButton>
                </Col>
              )}
          </Row>
        </div>
        <Col md="12">
          <Row>
            <Col md="12">
              {m1.assignedTo && (
                <div>
                  <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Assigned To")} :</div>
                  <div style={themeService(maintenaceDetailstyle.fieldText)}>
                    {m1.assignedTo ? methods.getUserDisplay(m1.assignedTo) : "No user"}
                  </div>
                </div>
              )}
            </Col>
            <Col md="12">
              {(m1.status === "Closed" || m1.status === "Complete" || m1.status === "In Progress" || m1.status === "Planned") &&
                m1.dueDate && (
                  <div>
                    <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Plan Date")}: </div>
                    <div style={themeService(maintenaceDetailstyle.fieldText)}>{moment(m1.dueDate).format("ddd, MMM DD, YYYY")}</div>
                  </div>
                )}
            </Col>
            <Col md="12">
              {m1.executionDate && (
                <div>
                  <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Execution Date")}: </div>
                  <div style={themeService(maintenaceDetailstyle.fieldText)}>{moment(m1.executionDate).format("ddd, MMM DD, YYYY")}</div>
                </div>
              )}
            </Col>
            <Col md="12">
              {m1.closedDate && (
                <div>
                  <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Date Closed")}: </div>
                  <div style={themeService(maintenaceDetailstyle.fieldText)}>{moment(m1.closedDate).format("ddd, MMM DD, YYYY")}</div>
                </div>
              )}
            </Col>
            <Col md="12">
              {closedBy && (
                <div>
                  <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Closed By")}: </div>
                  <div style={themeService(maintenaceDetailstyle.fieldText)}>{closedBy}</div>
                </div>
              )}
            </Col>
          </Row>
        </Col>
      </Col>
    </Row>
  );
}

export default Description;



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/DetailViews/MaintenanceDescription.jsx